import './product-weights-overview.css';

import { Box, Spinner, SidePanel, Text, Snackbar, Snack } from "@nike/eds";
import { useDispatch, useSelector } from 'react-redux';
import { SearchComponent } from './Search/SearchComponent';
import { TableComponent } from './Table/TableComponent';
import { useEffect, useState } from "react";
import { selectLoadingForm, selectLoadingOverview, selectNotification, toggleNotification } from "../../shared/store/reducers/OverviewReducer";
import { Notification, Size } from '../../shared/Types';
import { FormComponent } from './Form/FormComponent';
import { StoreDispatch } from '../../shared/store/Store';

export function ProductWeightsOverview() {
    const dispatch: StoreDispatch = useDispatch();
    const isLoadingOverview: boolean = useSelector(selectLoadingOverview);
    const isLoadingForm: boolean = useSelector(selectLoadingForm);
    const notification: Notification = useSelector(selectNotification);

    const [updateSize, setUpdateSize] = useState<Size | null>(null);
    const [newSize, setNewSize] = useState<Size | null>(null);

    useEffect(() => {
        if (!isLoadingForm) {
            setUpdateSize(null);
            setNewSize(null);
        }
    }, [isLoadingForm]); 

    const onClickDismissSnack = () => {
        dispatch(toggleNotification(null));
    }

    return (
        <Box>
            <Snackbar>
                {notification && (
                    <Snack id="snack" status={notification.status} onDismiss={onClickDismissSnack} autoDismissDuration={15000}>
                        <p className="eds-type--body-2">{notification.message.replace(/^.+?(:) /, '')}</p>
                    </Snack>
                )}
            </Snackbar>

            <SidePanel onDismiss={() => setUpdateSize(null)} isOpen={updateSize !== null} headerSlot={<Text>{updateSize?.productWeightsKey.productCode}</Text>}>
                <FormComponent type='update' size={updateSize} />
            </SidePanel>

            <SidePanel onDismiss={() => setNewSize(null)} isOpen={newSize !== null} headerSlot={<Text>{newSize?.productWeightsKey.productCode}</Text>}>
                <FormComponent type='create' size={newSize} />
            </SidePanel>

            <Box mt={25}>
                <SearchComponent />
            </Box>

            <Box mt={100} className={isLoadingOverview ? 'loader' : 'hidden'}>
                <Spinner size="large" />
            </Box>
         
            <Box mt={25} className={isLoadingOverview ? 'hidden' : ''}>
                <TableComponent onEdit={(size: Size) => setUpdateSize(size)} onAdd={(size: Size) => setNewSize(size)} />
            </Box>
        </Box>
    )
}